import { useContext, useEffect } from "react";

import AuthContext from '../context/authentication/authContext';

function useAuth() {
    const {
        usuario,
        signIn,
        signUp,
        autenticado,
        usuarioAutenticado,
        logOut
    } = useContext(AuthContext);

    useEffect(() => {
        if (!usuario) {
            usuarioAutenticado();
        }
    }, [])

    return {
        usuario,
        signIn,
        signUp,
        autenticado,
        usuarioAutenticado,
        logOut
    }
}

export { useAuth };